import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminRoute from "@/components/AdminRoute";
import DashboardLayout from "@/components/DashboardLayout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Expenses from "@/pages/Expenses";
import JournalEntries from "@/pages/JournalEntries";
import Customers from "@/pages/Customers";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Security from "@/pages/Security";
import Organization from "@/pages/Organization";
import Masters from "@/pages/Masters";
import Wages from "@/pages/Wages";
import AIAssist from "@/pages/AIAssist";
import Receipts from "@/pages/Receipts";
import SuperAdmin from "@/pages/SuperAdmin";
import BillingHub from "@/pages/billing/BillingHub";
import SalesDocPage from "@/pages/billing/SalesDocPage";
import BillingProducts from "@/pages/billing/Products";
import BillingPayments from "@/pages/billing/Payments";
import AccountingLink from "@/pages/billing/AccountingLink";
import Welfare from "@/pages/billing/Welfare";
import FixedAssets from "@/pages/billing/FixedAssets";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Dashboard />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/expenses"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Expenses />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/journal"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <JournalEntries />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/receipts"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Receipts />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/customers"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Customers />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/reports"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Reports />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/settings"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Settings />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/security"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Security />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/organization"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Organization />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/masters"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Masters />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/wages"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Wages />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/ai"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <AIAssist />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/admin"
              element={
                <AdminRoute>
                  <DashboardLayout>
                    <SuperAdmin />
                  </DashboardLayout>
                </AdminRoute>
              }
            />

            {[
              { path: "/app/billing", el: <BillingHub /> },
              { path: "/app/billing/quotes", el: <SalesDocPage docType="quote" /> },
              { path: "/app/billing/orders", el: <SalesDocPage docType="order" /> },
              { path: "/app/billing/delivery", el: <SalesDocPage docType="delivery" /> },
              { path: "/app/billing/invoices", el: <SalesDocPage docType="invoice" /> },
              { path: "/app/billing/receipts", el: <SalesDocPage docType="receipt" /> },
              { path: "/app/billing/payment-notices", el: <SalesDocPage docType="payment_notice" /> },
              { path: "/app/billing/refund-notices", el: <SalesDocPage docType="refund_notice" /> },
              { path: "/app/billing/products", el: <BillingProducts /> },
              { path: "/app/billing/payments", el: <BillingPayments /> },
              { path: "/app/billing/accounting-link", el: <AccountingLink /> },
              { path: "/app/welfare", el: <Welfare /> },
              { path: "/app/fixed-assets", el: <FixedAssets /> },
            ].map((r) => (
              <Route
                key={r.path}
                path={r.path}
                element={
                  <ProtectedRoute>
                    <DashboardLayout>{r.el}</DashboardLayout>
                  </ProtectedRoute>
                }
              />
            ))}

            <Route path="/app/invoices" element={<Navigate to="/app/billing/invoices" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
